module.exports = __webpack_public_path__ + "img/noRisk.520a4f55.png";